// extracted by extract-css-chunks-webpack-plugin
module.exports = {"games":"games_4R-3v","bar":"bar_2gFNG","intro":"intro_fr68G"};